var _clipPath, _ellipse;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    viewBox: "0 0 295 295"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-circle",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.5,
    cy: 0.5,
    rx: 0.48,
    ry: 0.48
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.5,
    cy: 150,
    rx: 140,
    ry: 143
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwcHgiIHZpZXdCb3g9IjAgMCAyOTUgMjk1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICA8Y2xpcFBhdGggaWQ9ImNsaXAtY2lyY2xlIiBjbGlwUGF0aFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICA8ZWxsaXBzZSBjeD0iMC41IiBjeT0iMC41IiByeD0iMC40OCIgcnk9IjAuNDgiLz4KICA8L2NsaXBQYXRoPgogIDxlbGxpcHNlIGN4PSIxNDcuNSIgY3k9IjE1MCIgcng9IjE0MCIgcnk9IjE0MyIvPgo8L3N2Zz4K";
export { SvgCircle as ReactComponent };